function fbt_init_js() {

    const fbt = document.getElementById('wrap_fbt'),
    lb = document.querySelectorAll('.kl_fbt_li input.js_fbt_ck'),
    sl = document.querySelectorAll('.js_fbt_sl'),
    py = document.querySelectorAll('.fbt_pr_source'),
    slcb = document.querySelectorAll('.pr_fbt_ac_slcb'),
    fb_bd = parseFloat(fbt.querySelector('.js_wrap_group').dataset.boundle_discount);
    
    const slal = '.fbt_select_all_js',slnm = '.fbt_select_num_js';
    slcb.forEach(i=>{
       i.addEventListener('change',function(e){
            var t = e.currentTarget,
            ct = t.closest('.js_wrap_group'),
            fbt_opvs = ct.querySelectorAll('.js_fbt_input,.js_fbt_sl option:checked'),
            fbt_checkbox = ct.querySelectorAll('.js_fbt_ck'),
            fbt_property = ct.querySelectorAll('.js_grp_qty,.js_fbt_input,.js_fbt_sl'),
            fbt_num = ct.querySelector(slnm),
            fbt_btn = ct.querySelector('.kl_fbt_btn'),
            fbt_ttp = ct.querySelector('.kl_fbt_tt_price'),
            fbt_img = ct.querySelectorAll('.pr_fbt_img'),
            all_price = 0,
            sale_price = 0;
            if(t.checked){
                fbt_checkbox.forEach(e=>{e.checked=true});
                fbt_property.forEach(e=>{e.removeAttribute('disabled')});
                fbt_img.forEach(e=>{e.setAttribute('style','opacity:1')});
                const ttm = fbt_num.getAttribute('data-ttnum');
                fbt_num.setAttribute('data-num',ttm);
                fbt_num.innerText = `current selected items:${ttm}`;
                fbt_btn.classList.remove('disabled');
                fbt_btn.removeAttribute('disabled');
                fbt_opvs.forEach(e=>{
                    all_price = all_price + parseInt(e.getAttribute('data-ogprice'));
                    sale_price = sale_price + parseInt(e.getAttribute('data-price'));
                });
            }else{
                fbt_checkbox.forEach(e=>{e.checked=false});
                fbt_property.forEach(e=>{e.setAttribute('disabled','disabled')});
                fbt_img.forEach(e=>{e.setAttribute('style','opacity:.2')});
                fbt_num.setAttribute('data-num',0);
                fbt_num.innerText = `current selected item:0`;
                fbt_btn.classList.add('disabled');
                fbt_btn.setAttribute('disabled','');
            }
            fbt_ttp.setAttribute('data-cppr',all_price);
            fbt_ttp.setAttribute('data-pr',sale_price);
            if(all_price == sale_price){
                fbt_ttp.innerHTML = wsp.formatMoney(all_price);
            }else{
                fbt_ttp.innerHTML = `<ins>` + wsp.formatMoney(sale_price) + '</ins> <del>' + wsp.formatMoney(all_price) + '</del>'
            }
       }) 
    });
    lb.forEach(i=>{
        i.addEventListener('change',function(e){
            var t = e.target,
            cl = t.closest('.kl_fbt_li'),
            ci = cl.dataset.sl,
            cm = 'remove',
            st = t.checked;
            var ct = t.closest('form');
            function adjustSelectNum(ct,s){
                var slall = ct.querySelector(slal),
                slnum = ct.querySelector(slnm),
                fbt_btn = ct.querySelector('.kl_fbt_btn');
                if(slnum){
                    var cnum = parseInt(slnum.getAttribute('data-num')),
                    ttnum = parseInt(slnum.getAttribute('data-ttnum')),
                    nnum = s ? ++cnum : --cnum,
                    slhtml = nnum > 1?`current selected items:${nnum}`:`current selected item:${nnum}`;
                    slnum.setAttribute('data-num',nnum);
                    slnum.innerHTML = slhtml;
                    s ? ( nnum == ttnum && (slall.checked=true,slall.setAttribute('checked','checked'))):(slall.checked=false,slall.removeAttribute('checked'))
                    nnum == 0 ? (fbt_btn.classList.add('disabled'),fbt_btn.setAttribute('disabled','')):(fbt_btn.classList.remove('disabled'),fbt_btn.removeAttribute('disabled'));
                }
            }
            if(!st){
                ct.querySelector(ci).setAttribute('style','opacity:.2');
                cl.querySelectorAll('.js_grp_qty,.js_fbt_input,.js_fbt_sl').forEach(e=>{
                    e.setAttribute('disabled','');
                });
                cm = 'remove';
                adjustSelectNum(ct,0);
            }else{
                ct.querySelector(ci).setAttribute('style','opacity:1');
                cl.querySelectorAll('.js_grp_qty,.js_fbt_input,.js_fbt_sl').forEach(e=>{
                    e.removeAttribute('disabled');
                });
                cm = 'add';
                adjustSelectNum(ct,1);
            }
            var fb_ttp = ct.querySelector('.kl_fbt_tt_price'),
            ttp = parseInt(fb_ttp.dataset.cppr),
            ttcp = parseInt(fb_ttp.dataset.pr),
            cke = cl.querySelector('.js_fbt_input');
            if(!cke){cke = cl.querySelector('.js_fbt_sl option:checked')}
            var ckp = parseInt(cke.dataset.ogprice),
            ckcp = parseInt(cke.dataset.price);
            switch(cm){
                case 'remove':
                    ttp = ttp - ckp;
                    ttcp = ttcp - ckcp;
                    break;
                case 'add':
                    ttp = ttp + ckp;
                    ttcp = ttcp + ckcp;
                    break;
            }
            fb_ttp.setAttribute('data-cppr',ttp);
            fb_ttp.setAttribute('data-pr',ttcp);
            if(ttp == ttcp){
                fb_ttp.innerHTML = wsp.formatMoney(ttp);
            }else{
                fb_ttp.innerHTML = `<ins>` + wsp.formatMoney(ttcp) + '</ins> <del>' + wsp.formatMoney(ttp) + '</del>';
            }
        })
    });

    sl.forEach(i=>{
        i.addEventListener('change',function(e){
            var t = e.target,
            v = t.querySelector('option:checked'),
            vi = v.dataset.img,
            cl = t.closest('.kl_fbt_li'),
            ci = cl.dataset.sl,
            ct = t.closest('form'),
            fb_ttp = ct.querySelector('.kl_fbt_tt_price');
            ct.querySelector(ci + ' img').setAttribute('src',vi);
            var s_ttp = parseInt(t.dataset.ogprice),
            s_ttcp = parseInt(t.dataset.price),
            v_ttp = parseInt(v.dataset.ogprice),
            v_ttcp = parseInt(v.dataset.price),
            a_ttp = parseInt(fb_ttp.dataset.cppr),
            a_ttcp = parseInt(fb_ttp.dataset.pr);
            if(s_ttp != v_ttp){
                var mp = s_ttp - v_ttp;
                if(mp>0 || mp<0){
                    a_ttp -= mp;
                    fb_ttp.setAttribute('data-cppr',a_ttp);
                    t.setAttribute('data-ogprice',v_ttp);
                }
            }
            if(s_ttcp != v_ttcp){
                var mp = s_ttcp - v_ttcp;
                if(mp>0 || mp<0){
                    a_ttcp -= mp;
                    fb_ttp.setAttribute('data-pr',a_ttcp);
                    t.setAttribute('data-price',v_ttcp);
                }
            }
            var v_a_ttp = v_ttp,v_a_ttcp = v_ttcp;
            if(v_a_ttcp == v_a_ttp)cl.querySelector('.kl_fbt_price').innerHTML = wsp.formatMoney(v_a_ttcp);
            else cl.querySelector('.kl_fbt_price').innerHTML = `<ins>` + wsp.formatMoney(v_a_ttcp) + '</ins> <del>' + wsp.formatMoney(v_a_ttp) + '</del>';
            if(a_ttcp == a_ttp)fb_ttp.innerHTML = wsp.formatMoney(a_ttcp);
            else fb_ttp.innerHTML = `<ins>` + wsp.formatMoney(a_ttcp) + '</ins> <del>' + wsp.formatMoney(a_ttp) + '</del>';
        });
    });
    py.forEach(i=>{
        i.addEventListener('change',function(e){
            var t = e.target,
            vsku = t.querySelector('option:checked').dataset.sku,
            cf = t.closest('form'),
            py_pr = cf.querySelectorAll('.property_module');
            py_pr.forEach(d=>{
                d.setAttribute('value','product-fbt '+vsku);
            });
        });
    });
}
this.fbt_init_js();
